import React from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Helpers from '../helpers/util';

import Toggle from './Toggle';
import Travel from './Travel';
import Outbreak from './Outbreak';
import DiseasePrevalence from './DiseasePrevalence';
import BarIndicator from './BarIndicator';
import Searchbar from './Searchbar';

class Sidebar extends React.Component {
	handleDiseaseClick = () => {
		if (window.vaxihub) {
			const eventName = 'custom.event.travel_map--disease_tab_click'; // Created inside GTM
			const eventObject = Helpers.GTM.create(eventName);
			Helpers.GTM.push(eventObject);
		}
		Helpers.pubsub.publish('barIndicator', { show: false });
	};
	render() {
		// set unique CSSTransition key for switch
		let currentKey = this.props.location.pathname.includes('/travel') ? '/travel' : '/outbreak';
		return (
			<div className="sidebar">
				<div className="toggles">
					<a href="/" className="home-btn hide-desktop">
						<div className="icon icon-home" />
					</a>
					<React.Fragment>
						<Toggle
							onClick={(e) => {
								Helpers.pubsub.publish('barIndicator', { show: false });
							}}
							path="/travel"
							name="Travel"
							location={this.props.location}
						/>
						<Toggle
							onClick={this.handleDiseaseClick}
							path={`/${window.prevalence_tab_slug}`}
							name={`${window.prevalence_tab_title}`}
							location={this.props.location}
						/>
					</React.Fragment>
				</div>

				{/* <Switch location={this.props.location}>
					<Route path={`/${window.prevalence_tab_slug}/:disease?`} component={BarIndicator} />
				</Switch> */}

				{/* Search */}
				<Searchbar />
				{/* End search */}

				<TransitionGroup>
					<CSSTransition key={currentKey} timeout={1000} classNames="fade" appear>
						<div className="sidebar-inner">
							<Switch location={this.props.location}>
								<Route path="/travel" component={Travel} />
								<Route exact path="/outbreak" component={Outbreak} />
								<Route path={`/${window.prevalence_tab_slug}/:disease?`} component={DiseasePrevalence} />
								<Redirect to="/travel" />
							</Switch>
						</div>
					</CSSTransition>
				</TransitionGroup>
			</div>
		);
	}
}

export default withRouter(Sidebar);
